import { css, keyframes } from 'styled-components';
import { iconTokens } from '../../tokens/components/Icon/tokens';

const spin = keyframes`
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
`;

export const iconCore = css`
  fill: currentColor;
  stroke: currentColor;
  stroke-width: 0;
  -webkit-transform: translate(0px, 0px); // For Safari
`;

export const iconSizes = {
  xxs: iconTokens.SizeXxs,
  xs: iconTokens.SizeXs,
  sm: iconTokens.SizeSm,
  md: iconTokens.SizeMed,
  lg: iconTokens.SizeLg,
  xl: iconTokens.SizeXl,
  xxl: iconTokens.SizeXxl,
};

export const iconPlacements = {
  top: css``,
  up: css`
    transform: translateY(-2px);
  `,
  low: css`
    transform: translateY(2px);
  `,
  lower: css`
    transform: translateY(4px);
  `,
  lowest: css`
    transform: translateY(6px);
  `,
  xxlow: css`
    transform: translateY(8px);
  `,
};

export const iconSpinning = css`
  animation: ${spin} 2s linear infinite;
`;
